import type { ConceptDef } from '../types';

export const receptiveShapes: ConceptDef = {
  kind: 'tileMatch',
  id: 'receptive-shapes',
  label: 'Receptive Shapes',
  category: 'Receptive',
  description: 'Hear a shape name and tap the matching shape.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'circle', answer: '⭕ circle' },
      { say: 'square', answer: '◼ square' },
      { say: 'triangle', answer: '▲ triangle' },
      { say: 'star', answer: '★ star' },
      { say: 'heart', answer: '❤ heart' },
      { say: 'diamond', answer: '◆ diamond' },
    ],
  },
};
